import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { formatAccountName } from '../../utils/formatters';
import './Header.css';

interface HeaderProps {
  title: string;
  subtitle?: string;
  accountName?: string;
}

export const Header: React.FC<HeaderProps> = ({ title, subtitle, accountName }) => {
  const { user, signOut } = useAuth();

  return (
    <div className="header">
      <div className="header-content">
        <div>
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
          {accountName && <p className="account-name">{formatAccountName(accountName)}</p>}
        </div>
        {user && (
          <div className="header-user">
            <span>{user.email}</span>
            <button onClick={signOut} className="logout-btn">
              Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
